import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Checkbox,
  Button,
  Card,
  Container,
  FormControl,
  Autocomplete,
  TextField,
  Grid,
  Box,
  CardContent,
  MenuItem,
  Select,
  InputLabel,
  Stack,
  Typography,
  createFilterOptions,
  ListItemText,
  InputAdornment,
  Alert,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Table,
  TableHead,
  Chip,
  Divider,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Page from "src/components/Page";
import { getClientCameras } from 'src/api/clientDetails';

import {
  getCamerasList_Live,
  getGroupsByClient,
  getCamerasByGroupID,
  getCamerasList,
  getClientGroupInfo,
} from "src/api/liveCameras";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { getClientList } from "src/api/analytics";
import { VpnLockSharp } from "@mui/icons-material";
import DashboardNavbar from "src/layouts/dashboard/DashboardNavbar";
import { getClientLocations, getClientProperties } from 'src/api/ShiftMaster';
import { generateStreamURL } from 'src/utils/config';
import { jsonToParam } from 'src/utils/config';
import { addClientCameraPricing,getClientCameraPricing,updateClientCameraPricing } from "src/api/credits";
import Scrollbar from "src/components/Scrollbar";
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useEffectEvent } from "react";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const groupicon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const groupcheckedIcon = <CheckBoxIcon fontSize="small" />;

export default function CameraGrouping() {
  const agentBased = localStorage.getItem('IsAgentBased');
  const Type = localStorage.getItem('Type');
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedCameras, setSelectedCameras] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [liveCamerasList, setLiveCamerasList] = useState([]);
  const [clientGroupList, setClientGroupsList] = useState([]);
  const [camerasByGroupId, setCamerasByGroup] = useState([]);
  const [editCamerasByGroupId, seteditCamerasByGroup] = useState([]);
  const [camerawithoutGroups, setCameraListWithoutGroups] = useState([]);
  const [filteredCamerawithoutGroups, setFilteredCameraListWithoutGroups] = useState([]);
  const [showOptions, setShowOptions] = useState(true);
  const [gridLayout, setGridLayout] = useState({ xs: 12 });
  const [errorMessage, setErrorMessage] = useState('');
  const [checkValue, setCheckValue] = useState(false);
  const [groupCheckValue, setGroupCheckValue] = useState(false);
  const [openAuto, setOpenAuto] = useState(false);
  const [activeCameras, setActiveCameras] = useState([]);
  const [inputValue, setInputValue] = useState([]);
  const [activeGroups, setActiveGroups] = useState([]);
  const [outerBoxWidth, setOuterBoxWidth] = useState('');
  const [outerBoxHeight, setOuterBoxHeight] = useState('');
  const [cameWidth, setCamewidth] = useState('');
  const [cameHeight, setCameHeight] = useState('');
  const [xsCount, setXSCountVal] = useState(null);
  const [clientList, setClientList] = useState([]);
  const [clientName, selectedClientName] = useState([]);
  const [saveError, setSaveError] = useState(false);
  const [isClientSelected, setIsClientSelected] = useState(false);
  const [isClient, setIsClient] = useState('');
  const [totalCameras, setTotalCameras] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');
  const [errorGroup, setErrorGroup] = useState(null);
  const [client, setClient] = useState('');
  const [clientType, setClientType] = useState('');
  const [clientTypeerror, setClientTypeError] = useState('');
  const [setTypeClient, setSelectedTypeClient] = useState([]);
  const [groupinfo, setGroupinfo] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [type, setType] = useState('View');
  const [pricing, setPricing] = useState('');
  const [noOfCameras, setNoOfCameras] = useState('');
  const [noOfViews, setNoOfViews] = useState('');
  const [noOfViewsForBilling, setNoOfViewsForBilling] = useState('');
  const [storagePrice, setStoragePrice] = useState('');
  const [pricingError, setPricingError] = useState('');
  const [typeError, setTypeError] = useState('');
  const [status, setStatusBase] = useState(false);
  const [message, setMessage] = useState('');
  const [alertType, setAlertType] = useState('success');
  const [pricingData, setPricingData] = useState([]);
  const [assignedCameraIds, setAssignedCameraIds] = useState([]);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [editType, setEditType] = useState('');
  const [editPricing, setEditPricing] = useState('');
  const [editNoOfCameras, setEditNoOfCameras] = useState('');
  const [editNoOfViews, setEditNoOfViews] = useState('');
  const [editViewsConsideredForBilling, setEditViewsConsideredForBilling] = useState('');
  const [editStoragePrice, setEditStoragePrice] = useState('');
  const [editTypeError, setEditTypeError] = useState('');
  const [editPricingError, setEditPricingError] = useState('');
  const [editErrorMessage, setEditErrorMessage] = useState('');
  const [editActiveCameras, setEditActiveCameras] = useState([]);
  const [editSelectedCameras, setEditSelectedCameras] = useState([]);
  const [editCameraError, setEditCameraError] = useState('');
  const [editActiveGroups, setEditActiveGroups] = useState([]);
  const [editGroupCheckValue, setEditGroupCheckValue] = useState(false);
  const [editGroupError, setEditGroupError] = useState('');
  const [editClientGroupList, setEditClientGroupList] = useState([]);
  const [editGroupInfo, setEditGroupInfo] = useState([]);
  const [editClientLocationOptions, setEditClientLocationOptions] = useState([]);
  const [editSelectedLocation, setEditSelectedLocation] = useState(null);
  const [editLocationError, setEditLocationError] = useState('');
  const [clientGroupInfo,setClientGroupInfo] = useState([])
  const [isGroupedClient, setIsGroupedClient] = useState(false);



  const AssignClient = localStorage.getItem('AssignClient');
  const userType = localStorage.getItem('user_type');


  const [locations, setLocations] = useState([]);
  const [clientLocationOptions, setClientLocationOptions] = useState([]);
  const [selectedClientLocations, setSelectedClientLocations] = useState([]);
  const [locationError, setLocationError] = useState('');

  const [property, setProperty] = useState(() => {
    const stored = localStorage.getItem('selectedProperty');
    return stored ? parseInt(stored) : null;
  });
  const [properties, setProperties] = useState([]);

  const client_id = localStorage.getItem('client_id');

console.log('pricingdata:', pricingData);
  const hasTriggeredSubmit = useRef(false);

  const normalizeDisplayName = (name) =>
    String(name || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const buildUniqueClientOptions = (clients) => {
    const grouped = new Map();

    (clients || []).forEach((clientItem) => {
      const key = normalizeDisplayName(clientItem?.displayname);
      if (!key) return;

      if (!grouped.has(key)) {
        grouped.set(key, []);
      }

      grouped.get(key).push(clientItem);
    });

    return Array.from(grouped.values()).map((groupItems) => {
      if (groupItems.length === 1) return groupItems[0];

      const assignTargets = new Set(
        groupItems
          .map((item) => Number(item.AssignClient || 0))
          .filter((assignId) => assignId > 0)
      );

      const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
      if (mappedMain) return mappedMain;

      const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
      return rootEntry || groupItems[0];
    });
  };

  const uniqueClientOptions = useMemo(
    () => buildUniqueClientOptions(setTypeClient),
    [setTypeClient]
  );

  
const getClientNameById = (clientId) => {
  if (!clientId) return '';
  const client = uniqueClientOptions.find(client => client.ID === Number(clientId));
  return client ? client.displayname : String(clientId);
};

  const resolveMainClientByName = (clientName) => {
    const normalizedName = normalizeDisplayName(clientName);
    if (!normalizedName) return null;

    return uniqueClientOptions.find(
      (clientItem) => normalizeDisplayName(clientItem?.displayname) === normalizedName
    ) || null;
  };

  const normalizeLocationOptions = (locationsData) =>
    Array.from(
      new Map(
        (Array.isArray(locationsData) ? locationsData : (locationsData ? [locationsData] : []))
          .map((location) => ({
            ...location,
            ID: Number(location?.ID ?? location?.id ?? 0),
            Location: (location?.Location || location?.name || '').trim()
          }))
          .filter((location) => location.ID > 0)
          .map((location) => [location.ID, location])
      ).values()
    );

  const checkExistingPricing = (clientId, cameraIds, type, excludePricingId = null) => {
    
    const existingEntries = pricingData.filter(row => {
      if (row.client !== editingRow?.client) return false;
      if (row.type !== type) return false;
      
      const rowCameraIds = row.cameras.map(camera => camera.camera_id || camera.CameraId);
      const hasOverlap = cameraIds.some(cameraId => rowCameraIds.includes(cameraId));
      
      return hasOverlap;
    });
    
    return existingEntries.length > 0;
  };




 const loadEditGroupsAndCameras = (clientId, row, selectedLocationIds = []) => {

  const cameraIds = row.cameras
    .map((camera) => Number(camera.camera_id || camera.CameraId))
    .filter((cameraId) => cameraId > 0);
    
  const selectedLocationIdNumbers = (selectedLocationIds || [])
    .map((locationId) => Number(locationId))
    .filter((locationId) => locationId > 0);

  // Determine the target ID for groups API
  let targetIdForGroups;
  if (selectedLocationIdNumbers.length > 0) {
    // If location is selected, use location ID
    targetIdForGroups = selectedLocationIdNumbers.join(',');
  } else {
    // If no location selected, use client ID
    targetIdForGroups = clientId;
  }

  let body = { clientId: targetIdForGroups, groupId: 0 };

  getClientGroupInfo(body, (response) => {
    if (response.status === 200 && response.data.length > 0) {
      setEditGroupInfo(response.data);
      const uniqueGroups = Array.from(
        new Map(response.data.map(item => [item.GroupId, {
          GroupId: item.GroupId,
          GroupName: item.GroupName
        }])).values()
      );
      setEditClientGroupList(uniqueGroups);

      // Find which groups contain the cameras from the row
      const groupsWithCameras = new Set();
      response.data.forEach(item => {
        if (cameraIds.includes(Number(item.deviceid))) {
          groupsWithCameras.add(item.GroupId);
        }
      });

      setEditActiveGroups(Array.from(groupsWithCameras));
      setEditGroupCheckValue(
        uniqueGroups.length > 0 && groupsWithCameras.size === uniqueGroups.length
      );

      const selectedCameraObjects = response.data.filter((camera) =>
        cameraIds.includes(Number(camera.deviceid))
      );
      
      if (selectedCameraObjects.length > 0) {
        setEditActiveCameras(selectedCameraObjects.map((camera) => camera.deviceid));
        setEditSelectedCameras(selectedCameraObjects);
      } else {
        setEditActiveCameras(cameraIds);
        setEditSelectedCameras([]);
      }
      return;
    }

    setEditGroupInfo([]);
    setEditClientGroupList([]);
    setEditActiveGroups([]);
    setEditGroupCheckValue(false);

    const selectedCameraObjects = totalCameras.filter((camera) => {
      const cameraClientId = getCameraClientId(camera);
      const matchesLocation = selectedLocationIdNumbers.length > 0
        ? selectedLocationIdNumbers.includes(cameraClientId)
        : cameraClientId === Number(clientId);

      return matchesLocation && cameraIds.includes(Number(camera.deviceid));
    });

    setEditActiveCameras(
      selectedCameraObjects.length > 0
        ? selectedCameraObjects.map((camera) => camera.deviceid)
        : cameraIds
    );
    setEditSelectedCameras(selectedCameraObjects);
  });
};

	 const handleEdit = (row) => {
	  if (row && Object.prototype.hasOwnProperty.call(row, 'ClientId')) {
      console.log('Editing row with ClientId:', row);
	    setEditingRow(row);
	    setEditType('');
	    setEditPricing(String(row?.TotalPrice ?? ''));
	    setEditNoOfCameras(String(row?.NoOfCameras ?? ''));
	    setEditNoOfViews(String(row?.NoOfViews ?? ''));
	    setEditViewsConsideredForBilling(String(row?.ViewsConsideredForBilling ?? ''));
	    setEditStoragePrice(String(row?.StoragePrice ?? ''));
	    setEditTypeError('');
	    setEditPricingError('');
	    setEditCameraError('');
	    setEditGroupError('');
	    setEditErrorMessage('');
	    setEditLocationError('');
	    setEditClientLocationOptions([]);
	    setEditSelectedLocation(null);
	    setEditDialogOpen(true);
	    return;
	  }

	  setEditingRow(row);
	  setEditType(row.type);
	  setEditPricing(row.price.toString());
  setEditTypeError('');
  setEditPricingError('');
  setEditCameraError('');
  setEditGroupError('');
  setEditErrorMessage('');
  setEditLocationError('');
  setEditClientLocationOptions([]);
  setEditSelectedLocation(null);
  
  // Get all camera IDs from the row
  const cameraIds = row.cameras.map(camera => camera.camera_id || camera.CameraId);
  
  const clientFromList = resolveMainClientByName(row.client);
  
  if (clientFromList) {
    setEditSelectedCameras([]);
    setEditActiveGroups([]);
    setEditClientGroupList([]);
    setEditGroupInfo([]);
    setEditActiveCameras(cameraIds);

    // First load locations for this client
    getClientProperties({ AssignClient: String(clientFromList.ID) }, (locationResponse) => {
      if (locationResponse.status === 200) {
        const normalizedLocations = normalizeLocationOptions(locationResponse.data);
        setEditClientLocationOptions(normalizedLocations);
        
        // Find the matching location from the row
        const matchedLocation = normalizedLocations.find(
          (location) => location.Location === row.location
        ) || null;
        
        setEditSelectedLocation(matchedLocation);
        
        // Determine what ID to use for groups API
        let targetIdForGroups;
        if (matchedLocation && row.location) {
          // If row has a location, use location ID
          targetIdForGroups = matchedLocation.ID;
        } else {
          // If no location, use client ID
          targetIdForGroups = clientFromList.ID;
        }
        
        // Load groups using the appropriate ID
        let body = { clientId: targetIdForGroups, groupId: 0 };
        
        getClientGroupInfo(body, (response) => {
          if (response.status === 200 && response.data.length > 0) {
            // Store all group info
            setEditGroupInfo(response.data);
            
            // Get unique groups
            const uniqueGroups = Array.from(
              new Map(response.data.map(item => [item.GroupId, {
                GroupId: item.GroupId,
                GroupName: item.GroupName
              }])).values()
            );
            setEditClientGroupList(uniqueGroups);

            // Find which groups contain the cameras from the editing row
            const groupsWithCameras = new Set();
            response.data.forEach(item => {
              if (cameraIds.includes(Number(item.deviceid))) {
                groupsWithCameras.add(item.GroupId);
              }
            });
            
            // Set the groups that should be checked
            setEditActiveGroups(Array.from(groupsWithCameras));
            setEditGroupCheckValue(
              uniqueGroups.length > 0 && groupsWithCameras.size === uniqueGroups.length
            );

            // Get all cameras from the checked groups
            let allGroupCameras = [];
            if (groupsWithCameras.size > 0) {
              allGroupCameras = response.data.filter(item => 
                groupsWithCameras.has(item.GroupId)
              );
            } else {
              // If no groups contain the cameras, get all cameras for this location/client
              allGroupCameras = response.data;
            }
            
            // Find the specific cameras from the row within the group cameras
            const selectedCameraObjects = allGroupCameras.filter((camera) =>
              cameraIds.includes(Number(camera.deviceid))
            );
            
            // Set selected cameras
            setEditSelectedCameras(selectedCameraObjects);
            setEditActiveCameras(selectedCameraObjects.map((camera) => camera.deviceid));
            
          } else {
            // No groups found for this location/client
            setEditGroupInfo([]);
            setEditClientGroupList([]);
            setEditActiveGroups([]);
            setEditGroupCheckValue(false);
            
            // Get all cameras for this location/client
            let allCameras = [];
            if (matchedLocation && row.location) {
              allCameras = totalCameras.filter((camera) => 
                getCameraClientId(camera) === Number(matchedLocation.ID)
              );
            } else {
              allCameras = totalCameras.filter((camera) => 
                getCameraClientId(camera) === Number(clientFromList.ID)
              );
            }
            
            // Find the specific cameras from the row
            const selectedCameraObjects = allCameras.filter((camera) =>
              cameraIds.includes(Number(camera.deviceid))
            );
            
            setEditSelectedCameras(selectedCameraObjects);
            setEditActiveCameras(selectedCameraObjects.map((camera) => camera.deviceid));
            setEditGroupInfo(allCameras); // Store all cameras for dropdown
          }
        });
      } else {
        // No locations found, use client ID directly
        setEditClientLocationOptions([]);
        setEditSelectedLocation(null);
        
        // Load groups using client ID
        let body = { clientId: clientFromList.ID, groupId: 0 };
        
        getClientGroupInfo(body, (response) => {
          if (response.status === 200 && response.data.length > 0) {
            setEditGroupInfo(response.data);
            const uniqueGroups = Array.from(
              new Map(response.data.map(item => [item.GroupId, {
                GroupId: item.GroupId,
                GroupName: item.GroupName
              }])).values()
            );
            setEditClientGroupList(uniqueGroups);

            // Find which groups contain the cameras
            const groupsWithCameras = new Set();
            response.data.forEach(item => {
              if (cameraIds.includes(Number(item.deviceid))) {
                groupsWithCameras.add(item.GroupId);
              }
            });
            
            setEditActiveGroups(Array.from(groupsWithCameras));
            setEditGroupCheckValue(
              uniqueGroups.length > 0 && groupsWithCameras.size === uniqueGroups.length
            );

            // Get all cameras from checked groups
            let allGroupCameras = [];
            if (groupsWithCameras.size > 0) {
              allGroupCameras = response.data.filter(item => 
                groupsWithCameras.has(item.GroupId)
              );
            } else {
              allGroupCameras = response.data;
            }
            
            const selectedCameraObjects = allGroupCameras.filter((camera) =>
              cameraIds.includes(Number(camera.deviceid))
            );
            
            setEditSelectedCameras(selectedCameraObjects);
            setEditActiveCameras(selectedCameraObjects.map((camera) => camera.deviceid));
            
          } else {
            setEditGroupInfo([]);
            setEditClientGroupList([]);
            setEditActiveGroups([]);
            setEditGroupCheckValue(false);
            
            // Get all cameras for this client
            const clientCameras = totalCameras.filter((camera) => 
              getCameraClientId(camera) === Number(clientFromList.ID)
            );
            
            const selectedCameraObjects = clientCameras.filter((camera) =>
              cameraIds.includes(Number(camera.deviceid))
            );
            
            setEditSelectedCameras(selectedCameraObjects);
            setEditActiveCameras(selectedCameraObjects.map((camera) => camera.deviceid));
            setEditGroupInfo(clientCameras);
          }
        });
      }
    });
  }
  
  setEditDialogOpen(true);
};

// const handleEdit = (row) => {

//   setEditingRow(row);
//   setEditType(row.type);
//   setEditPricing(row.price.toString());
//   setEditTypeError('');
//   setEditPricingError('');
//   setEditCameraError('');
//   setEditGroupError('');
//   setEditErrorMessage('');
//   setEditLocationError('');
//   setEditClientLocationOptions([]);
//   setEditSelectedLocation(null);
  
//   // Get all camera IDs from the row
//   const cameraIds = row.cameras.map(camera => camera.camera_id || camera.CameraId);
//   setEditActiveCameras(cameraIds);
  
//   const clientFromList = resolveMainClientByName(row.client);
  
//   if (clientFromList) {
//     setEditSelectedCameras([]);
//     setEditActiveGroups([]);
//     setEditClientGroupList([]);
//     setEditGroupInfo([]);

//     getClientProperties({ AssignClient: String(clientFromList.ID) }, (locationResponse) => {
//       if (locationResponse.status === 200) {
//         const normalizedLocations = normalizeLocationOptions(locationResponse.data);
//         setEditClientLocationOptions(normalizedLocations);

//         if (normalizedLocations.length > 0) {
//           const matchedLocation =
//             normalizedLocations.find((location) => location.Location === row.location) ||
//             null;

//           setEditSelectedLocation(matchedLocation);
//           if (matchedLocation) {
//             loadEditGroupsAndCameras(
//               clientFromList.ID,
//               row,
//               [matchedLocation.ID]
//             );
//           }
//           return;
//         }
//       }

//       setEditClientLocationOptions([]);
//       setEditSelectedLocation(null);
//       loadEditGroupsAndCameras(clientFromList.ID, row, []);
//     });
//   }
  
//   setEditDialogOpen(true);
// };

  const handleEditLocationChange = (_, value) => {
    setEditSelectedLocation(value || null);
    setEditLocationError('');
    setEditActiveCameras([]);
    setEditSelectedCameras([]);
    setEditActiveGroups([]);
    setEditClientGroupList([]);
    setEditGroupInfo([]);
    setEditGroupCheckValue(false);

    if (!editingRow) return;

    const clientFromList = resolveMainClientByName(editingRow.client);
    if (!clientFromList) return;

    if (editClientLocationOptions.length > 0 && !value) {
      setEditLocationError('Please select a location');
      return;
    }

    loadEditGroupsAndCameras(
      clientFromList.ID,
      editingRow,
      value?.ID ? [value.ID] : []
    );
  };

const handleEditGroupChange = (event, val) => {
  const containsAllProperty = val.some(obj => obj.hasOwnProperty('all'));
  
  if (editClientGroupList.length === editActiveGroups.length && containsAllProperty) {
    // Unselect all groups
    setEditGroupCheckValue(false);
    setEditActiveGroups([]);
    setEditActiveCameras([]);
    setEditSelectedCameras([]);
  } else if (containsAllProperty) {
    // Select all groups
    setEditGroupCheckValue(true);
    let groupIds = editClientGroupList.map(val => val.GroupId);
    setEditActiveGroups(groupIds);
    
    // Get all cameras from all groups
    const camerasFromAllGroups = editGroupInfo.filter(item => 
      groupIds.includes(item.GroupId)
    );
    
    // Get unique cameras (remove duplicates)
    const uniqueCameras = [];
    const cameraMap = new Map();
    camerasFromAllGroups.forEach(camera => {
      if (!cameraMap.has(camera.deviceid)) {
        cameraMap.set(camera.deviceid, camera);
        uniqueCameras.push(camera);
      }
    });
    
    const cameraIds = uniqueCameras.map(camera => camera.deviceid);
    setEditActiveCameras(cameraIds);
    setEditSelectedCameras(uniqueCameras);
  } else {
    const grpId = val[0]?.GroupId;
    if (!grpId) return;
    
    const isGroupSelected = editActiveGroups.includes(grpId);
    
    if (isGroupSelected) {
      // Remove group
      const newActiveGroups = editActiveGroups.filter(item => item !== grpId);
      setEditActiveGroups(newActiveGroups);
      setEditGroupCheckValue(false);
      
      // Remove cameras from this group
      const camerasFromRemovedGroup = editGroupInfo.filter(item => item.GroupId === grpId);
      const removedCameraIds = new Set(camerasFromRemovedGroup.map(camera => camera.deviceid));
      
      const newActiveCameras = editActiveCameras.filter(cameraId => 
        !removedCameraIds.has(cameraId)
      );
      setEditActiveCameras(newActiveCameras);
      
      const newSelectedCameras = editSelectedCameras.filter(camera => 
        !removedCameraIds.has(camera.deviceid)
      );
      setEditSelectedCameras(newSelectedCameras);
      
    } else {
      // Add group
      const newActiveGroups = [...editActiveGroups, grpId];
      setEditActiveGroups(newActiveGroups);
      
      // Add cameras from this group
      const camerasFromGroup = editGroupInfo.filter(item => item.GroupId === grpId);
      const newCameraIds = camerasFromGroup.map(camera => camera.deviceid);
      
      // Merge and remove duplicates
      const combinedCameraIds = [...new Set([...editActiveCameras, ...newCameraIds])];
      setEditActiveCameras(combinedCameraIds);
      
      // Merge selected cameras
      const existingCameraIds = new Set(editSelectedCameras.map(c => c.deviceid));
      const newCameras = camerasFromGroup.filter(camera => !existingCameraIds.has(camera.deviceid));
      const combinedCameras = [...editSelectedCameras, ...newCameras];
      setEditSelectedCameras(combinedCameras);
    }
  }
  
  if (editGroupError) setEditGroupError('');
  if (editCameraError) setEditCameraError('');
};

  const getCameraClientId = (camera) =>
    Number(camera?.clientid ?? camera?.client_id ?? camera?.ClientId ?? 0);

  const loadGroupsAndCameras = (selectedClientId, selectedLocationIds = []) => {
    const selectedLocationIdNumbers = (selectedLocationIds || [])
      .map((locationId) => Number(locationId))
      .filter((locationId) => locationId > 0);

    const targetClientIdForGroups = selectedLocationIdNumbers.length > 0
      ? selectedLocationIdNumbers.join(',')
      : selectedClientId;

    let body = { clientId: targetClientIdForGroups, groupId: 0 };

    getClientGroupInfo(body, (response) => {
      if (response.status === 200 && response.data.length > 0) {
        setGroupinfo(response.data);
        const uniqueGroups = Array.from(
          new Map(response.data.map(item => [item.GroupId, { GroupId: item.GroupId, GroupName: item.GroupName }])).values()
        );
        setClientGroupsList(uniqueGroups);
        setIsGroupedClient(true);
        setCameraListWithoutGroups([]);
        return;
      }

      setGroupinfo([]);
      setClientGroupsList([]);
      setCamerasByGroup([]);
      setIsGroupedClient(false);

      const sourceCameras = totalCameras || [];
      const fallbackCameras = selectedLocationIdNumbers.length > 0
        ? sourceCameras.filter((camera) => selectedLocationIdNumbers.includes(getCameraClientId(camera)))
        : sourceCameras.filter((camera) => getCameraClientId(camera) === Number(selectedClientId));

      setCameraListWithoutGroups(fallbackCameras);
    });
  };

  const handleLocationChange = (event, value) => {
    if (!selectedClient?.ID) return;

    const selectedLocationId = Number(value?.ID ?? value?.id ?? 0);
    const nextSelectedLocations = selectedLocationId > 0 ? [selectedLocationId] : [];

    setSelectedClientLocations(nextSelectedLocations);
    setLocationError('');
	    setActiveGroups([]);
	    setGroupCheckValue(false);
	    setActiveCameras([]);
	    setInputValue([]);
	    setCheckValue(false);

    // Locations drive groups/cameras; when none selected, clear dependent dropdowns.
    if (clientLocationOptions.length > 0 && nextSelectedLocations.length === 0) {
      setGroupinfo([]);
      setClientGroupsList([]);
      setCamerasByGroup([]);
      setCameraListWithoutGroups([]);
      return;
    }

    loadGroupsAndCameras(selectedClient.ID, nextSelectedLocations);
  };

	  const handleClient = (_, value) => {
	    setClientGroupsList([]);
	    setCameraListWithoutGroups([]);
	    setCamerasByGroup([]);
	    setLiveCamerasList([]);
	    setOpenAuto(false);
	    setIsGroupedClient(false);
	    setClientLocationOptions([]);
	    setSelectedClientLocations([]);
    setLocationError('');
    setActiveGroups([]);
	    setGroupCheckValue(false);
	    setActiveCameras([]);
	    setInputValue([]);

	      if (value) {
      if (checkValue) {
        setCheckValue(!checkValue);
      }

      const clientId = value.ID;
      setClient(clientId);

	      getClientProperties({ AssignClient: String(clientId) }, (response) => {
	        if (response.status === 200) {
	          const normalizedLocations = normalizeLocationOptions(response.data);

          setClientLocationOptions(normalizedLocations);

          if (normalizedLocations.length > 0) {
            setSelectedClientLocations([]);
            setClientGroupsList([]);
            setGroupinfo([]);
            setCamerasByGroup([]);
            setCameraListWithoutGroups([]);
            return;
          }
        }

        setClientLocationOptions([]);
        setSelectedClientLocations([]);
        loadGroupsAndCameras(clientId, []);
      });
    } else {
      setClient('');
    }
  };

  useEffect(() => {
    if (userType === "2") {
      setIsClient(true);
    } else {
      setIsClient(false);
    }

  getClientList((response) => {
        if (response.status === 200) {
          const usClients = response.data.filter(client => client.ClientType === "US" && client.EnvironmentType!==0);
          const sortedData = [...usClients].sort((a, b) =>
            a.displayname.trim().localeCompare(b.displayname.trim())
          );
          setClientList(sortedData);
          setSelectedTypeClient(sortedData); 
        }
      });
  }, []);

  useEffect(()=>{
    getClientCamerasList();
    getClientCameraPricing((response)=>{
      if(response.status===200){
      
        const processedData = processPricingData(response.data);
        setPricingData(processedData);
        setAssignedCameraIds([]);
      }
    })
  },[])



  const processPricingData = (apiData) => {
    if (!Array.isArray(apiData)) {
      console.error('API data is not an array:', apiData);
      return [];
    }

    return apiData.map((item, index) => ({
      id: item?.ID ?? item?.id ?? index + 1,
      ClientName: item?.client_name ?? item?.client_name ?? '',
      ClientId: item?.ClientId ?? item?.client_id ?? item?.clientId ?? '',
      NoOfCameras: item?.NoOfCameras ?? item?.no_of_cameras ?? '',
      NoOfViews: item?.NoOfViews ?? item?.no_of_views ?? '',
      ViewsConsideredForBilling: item?.ViewsConsideredForBilling ?? item?.views_considered_for_billing ?? '',
      TotalPrice: item?.TotalPrice ?? item?.total_price ?? '',
      StoragePrice: item?.StoragePrice ?? item?.storage_price ?? '',
      Location: item?.Location ?? item?.Location ?? '',
    }));
  };


  const getClientCamerasList = () => {
    
    let bodyParams = {};
    if(userType === "2") {
      if (!['share', 'sub', 'merge'].includes(Type)) {
        bodyParams.status = '0,1';
        if (property !== null) {
          bodyParams.property_id = Number(property);
        } else {
          bodyParams.clientid = Number(client_id);
        } 
      }
    }

    bodyParams = jsonToParam(bodyParams);

 

    getClientCameras(bodyParams, (response) => {
      if (response.status === 200) {
        if (response.data !== null) {
          setTotalCameras(response.data);
          if (userType === '2') {
            setCameraListWithoutGroups(response.data);
          } else {
            setTotalCameras(response.data);
          }
        }
      }
    });
  }
  
  // Removed the useEffect that filtered clients based on clientType

  useEffect(() => {
    setGroupinfo([]);
    setClientGroupsList([]);
    setCheckValue(false);
    setActiveCameras([]);
    setCamerasByGroup([]);
    setCameraListWithoutGroups([]);
    setSelectedClient(null);
    setLiveCamerasList([]);
    
    // Since we're showing all clients directly, we don't need to filter by clientType
    // The clientList is already loaded with all clients in the main useEffect
  }, []); // Removed clientType dependency

  useEffect(() => {
    if (activeGroups.length > 0) {
      const cameras = groupinfo.filter(val => activeGroups.includes(val.GroupId));
      setCamerasByGroup(cameras);
    }
  }, [activeGroups, groupinfo]);

  useEffect(() => {
    if (!client || isGroupedClient) return;

    if (clientLocationOptions.length > 0) {
      const locationIds = selectedClientLocations
        .map((locationId) => Number(locationId))
        .filter((locationId) => locationId > 0);

      if (locationIds.length === 0) {
        setCameraListWithoutGroups([]);
        return;
      }

      const locationCameras = totalCameras.filter((camera) =>
        locationIds.includes(getCameraClientId(camera))
      );
      setCameraListWithoutGroups(locationCameras);
      return;
    }

    const clientCameras = totalCameras.filter((camera) => getCameraClientId(camera) === Number(client));
    setCameraListWithoutGroups(clientCameras);
  }, [client, isGroupedClient, totalCameras, clientLocationOptions, selectedClientLocations]);

  


 


  useEffect(() => {
    if (activeGroups.length === clientGroupList.length && activeGroups.length > 0) {
      setGroupCheckValue(true);
    }
  }, [activeGroups, clientGroupList]);



  const handleGroupChange = (event, val) => {
    if (event.target.value && errorGroup) {
      setErrorGroup(null);
    }

    setCheckValue(false);
    const containsAllProperty = val.some(obj => obj.hasOwnProperty('all'));

    if (clientGroupList.length === activeGroups.length && containsAllProperty) {
      setGroupCheckValue(false);
      setActiveGroups([]);
      setCheckValue(false);
      setActiveCameras([]);
      setCamerasByGroup([]);
    } else if (containsAllProperty) {
      setGroupCheckValue(true);
      let groupId = clientGroupList.map(val => val.GroupId);
      setActiveGroups(groupId);
    } else {
      const grpId = val[0].GroupId;
      const avail = activeGroups.length > 0 ? activeGroups.filter(item => item === grpId) : [];

      if (avail.length > 0) {
        const id = activeGroups.filter(item => item !== grpId);
        setActiveGroups(id);
        setGroupCheckValue(false);

        if (id.length === 0) {
          setCheckValue(false);
          setActiveCameras([]);
          setCamerasByGroup([]);
        }
      } else {
        setActiveGroups((id) => [...id, grpId]);
      }
    }
  };

 

  const handleSubmit = () => {
	    setSaveError(false);
	    setErrorGroup(null);
	    setTypeError('');
	    setPricingError('');
	    setErrorMessage('');
	    setLocationError('');
    
    

    if (!isClient && !selectedClient) {
      setSaveError(true);
      return;
    }

	    const selectedLocationId = Number(selectedClientLocations[0] || 0);

    if (!pricing) {
      setPricingError('Please enter total price');
      return;
    }

	    if (isNaN(pricing) || parseFloat(pricing) <= 0) {
	      setPricingError('Please enter a valid positive number');
	      return;
	    }

    let clientId;
    if (isClient) {
      clientId = localStorage.getItem('client_id');
    } else {
      clientId = selectedClient?.ID;
    }

	    const payloadClientId = selectedLocationId > 0 ? selectedLocationId : Number(clientId);

    const pricingAlreadyExists = pricingData.some(
      (row) => Number(row.ClientId) === Number(payloadClientId)
    );

    if (pricingAlreadyExists) {
      setErrorMessage('Pricing already exists for this client. Please use the edit option.');
      return;
    }

    const toNumberOrZero = (value) => {
      if (value === '' || value === null || value === undefined) return 0;
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const requestBody = {
      ClientId: parseInt(payloadClientId),
      NoOfCameras: toNumberOrZero(noOfCameras),
      NoOfViews: toNumberOrZero(noOfViews),
      ViewsConsideredForBilling: toNumberOrZero(noOfViewsForBilling),
      TotalPrice: parseFloat(pricing),
      StoragePrice: toNumberOrZero(storagePrice)
    };

   

    addClientCameraPricing(requestBody, (response) => {
      if (response.status === 200 || response.status === 201) {
       
        setMessage('Pricing added successfully!');
        setAlertType('success');
        setStatusBase(true);
        handleClear();
        
        // Refresh pricing data
        getClientCameraPricing((response) => {
          if (response.status === 200) {
           
            const processedData = processPricingData(response.data);
            setPricingData(processedData);
            setAssignedCameraIds([]);
            setClientGroupsList([])
            setCameraListWithoutGroups([])
            setCamerasByGroup([])
          }
        });
      } else {
        setMessage(`Data insertion failed`);
        setAlertType('error');
        setStatusBase(true);
      }
    }, (error) => {
      console.error('API call failed:', error);
      setMessage(`Network error. Please try again.`);
      setAlertType('error');
      setStatusBase(true);
    });
  };

	  const handleSaveEdit = () => {
  setEditTypeError('');
  setEditPricingError('');
  setEditCameraError('');
  setEditGroupError('');
	  setEditErrorMessage('');
	  setEditLocationError('');

	  if (editingRow && Object.prototype.hasOwnProperty.call(editingRow, 'ClientId')) {
	    if (!editPricing) {
	      setEditPricingError('Please enter total price');
	      return;
	    }

	    if (isNaN(editPricing) || parseFloat(editPricing) <= 0) {
	      setEditPricingError('Please enter a valid positive number');
	      return;
	    }

	    const toNumberOrZero = (value) => {
	      if (value === '' || value === null || value === undefined) return 0;
	      const parsed = Number(value);
	      return Number.isFinite(parsed) ? parsed : 0;
	    };

	    const requestBody = {
	      ClientId: Number(editingRow.ClientId),
	      NoOfCameras: toNumberOrZero(editNoOfCameras),
	      NoOfViews: toNumberOrZero(editNoOfViews),
	      ViewsConsideredForBilling: toNumberOrZero(editViewsConsideredForBilling),
	      TotalPrice: parseFloat(editPricing),
	      StoragePrice: toNumberOrZero(editStoragePrice)
	    };

	    updateClientCameraPricing(requestBody, (response) => {
	      if (response.status === 200 || response.status === 201) {
	        setMessage('Pricing updated successfully!');
	        setAlertType('success');
	        setStatusBase(true);
	        getClientCameraPricing((response) => {
	          if (response.status === 200) {
	            setPricingData(processPricingData(response.data));
	            setAssignedCameraIds([]);
	          }
	        });
	        handleCloseEditDialog();
	      } else {
	        setEditErrorMessage('Update failed');
	      }
	    }, (error) => {
	      console.error('API call failed:', error);
	      setEditErrorMessage('Network error. Please try again.');
	    });
	    return;
	  }

	  if (!editPricing) {
    setEditPricingError('Please enter pricing');
    return;
  }

  if (isNaN(editPricing) || parseInt(editPricing) <= 0) {
    setEditPricingError('Please enter a valid positive number');
    return;
  }

  const clientFromList = resolveMainClientByName(editingRow.client);

  if (!clientFromList) {
    setEditErrorMessage('Client not found');
    return;
  }

  const getPricingCameraIds = (cameras = []) =>
    cameras
      .map((camera) => Number(camera?.camera_id || camera?.CameraId || camera?.deviceid || camera))
      .filter((cameraId) => cameraId > 0);

  const editedCameraIds = getPricingCameraIds(editingRow.cameras);

  if (editedCameraIds.length === 0) {
    setEditErrorMessage('No cameras found for this pricing row');
    return;
  }

  const rowMatchedLocation = editClientLocationOptions.find(
    (location) =>
      normalizeDisplayName(location?.Location) === normalizeDisplayName(editingRow?.location)
  );
  const selectedEditLocationId = Number(
    editSelectedLocation?.ID ??
    editSelectedLocation?.id ??
    rowMatchedLocation?.ID ??
    rowMatchedLocation?.id ??
    0
  );
  const cameraMatchedLocationId = totalCameras
    .map((camera) => ({
      cameraId: Number(camera?.deviceid),
      clientId: getCameraClientId(camera)
    }))
    .find((camera) =>
      editedCameraIds.includes(camera.cameraId) &&
      camera.clientId > 0 &&
      camera.clientId !== Number(clientFromList.ID)
    )?.clientId || 0;
  const hasEditLocationOptions =
    editClientLocationOptions.length > 0 ||
    selectedEditLocationId > 0 ||
    cameraMatchedLocationId > 0 ||
    !!editingRow?.location;
  const payloadClientId = hasEditLocationOptions
    ? (selectedEditLocationId || cameraMatchedLocationId || Number(clientFromList.ID))
    : Number(clientFromList.ID);
  const selectedEditLocationName =
    editSelectedLocation?.Location || rowMatchedLocation?.Location || editingRow?.location || '';
  const payloadClientCameraIds = new Set(
    totalCameras
      .filter((camera) => getCameraClientId(camera) === Number(payloadClientId))
      .map((camera) => Number(camera.deviceid))
      .filter((cameraId) => cameraId > 0)
  );
  const isEditingScopeRow = (row) => {
    if (row.client !== editingRow.client) return false;
    if (!hasEditLocationOptions) return true;

    const locationMatches =
      normalizeDisplayName(row.location) === normalizeDisplayName(selectedEditLocationName);
    const rowCameraIds = getPricingCameraIds(row.cameras);
    const cameraMatches =
      payloadClientCameraIds.size > 0 &&
      rowCameraIds.some((cameraId) => payloadClientCameraIds.has(cameraId));
    const editedCameraMatches =
      rowCameraIds.some((cameraId) => editedCameraIds.includes(cameraId));

    return locationMatches || cameraMatches || editedCameraMatches;
  };

  const pricingByCameraId = new Map();

  pricingData
    .filter(isEditingScopeRow)
    .forEach((row) => {
      (row.cameras || []).forEach((camera) => {
        const cameraId = Number(camera?.camera_id || camera?.CameraId || camera?.deviceid);
        if (cameraId <= 0) return;

        pricingByCameraId.set(cameraId, {
          CameraId: parseInt(cameraId),
          Pricing: parseInt(camera?.Pricing ?? row.price ?? editPricing),
          PricingType: row.type
        });
      });
    });

  (editingRow.cameras || []).forEach((camera) => {
    const cameraId = Number(camera?.camera_id || camera?.CameraId || camera?.deviceid);
    if (cameraId <= 0 || pricingByCameraId.has(cameraId)) return;

    pricingByCameraId.set(cameraId, {
      CameraId: parseInt(cameraId),
      Pricing: parseInt(camera?.Pricing ?? editingRow.price ?? editPricing),
      PricingType: editingRow.type
    });
  });

  editedCameraIds.forEach((cameraId) => {
    pricingByCameraId.set(cameraId, {
      CameraId: parseInt(cameraId),
      Pricing: parseInt(editPricing),
      PricingType: editingRow.type
    });
  });

  const requestBody = {
    ClientId: parseInt(payloadClientId),
    pricing: Array.from(pricingByCameraId.values()),
  };

  updateClientCameraPricing(requestBody, (response) => {

    if (response.status === 200 || response.status === 201) {
      setMessage('Pricing updated successfully!');
      setAlertType('success');
      setStatusBase(true);
      
      // Refresh pricing data
      getClientCameraPricing((response) => {
        if (response.status === 200) {
          
            const processedData = processPricingData(response.data);
            setPricingData(processedData);
            if(response.data){
              const assignedIds = response.data.flatMap(clientData => 
              Object.values(clientData)[0].flatMap(entry => 
                entry.cameras?.map(camera => camera.camera_id) || []
              ));
              setAssignedCameraIds(assignedIds);
            }
            else{
              setAssignedCameraIds([]);
            }          
        }
      });
      
      handleCloseEditDialog();
    } else {
      setMessage(`Update failed`);
      setAlertType('error');
      setStatusBase(true);
    }
  }, (error) => {
    console.error('API call failed:', error);
    setMessage(`Network error. Please try again.`);
    setAlertType('error');
    setStatusBase(true);
  });
};

const handleEditCameraChange = (event, newValue) => {
  
 
  const containsAllProperty = newValue.some(obj => obj.hasOwnProperty('all'));
  
  const allCameras = clientGroupList.length > 0 ? camerasByGroupId : camerawithoutGroups;
  
  if (containsAllProperty) {
    if (newValue.length === 1) {
      const allCameraIds = allCameras.map(camera => camera.deviceid);
      setEditActiveCameras(allCameraIds);
      setEditSelectedCameras(allCameras);
    } else {
      const filteredValue = newValue.filter(item => !item.all);
      const cameraIds = filteredValue.map(camera => camera.deviceid);
      setEditActiveCameras(cameraIds);
      setEditSelectedCameras(filteredValue);
    }
  } else {
    const cameraIds = newValue.map(camera => camera.deviceid);
    setEditActiveCameras(cameraIds);
    setEditSelectedCameras(newValue);
  }
  
  if (editCameraError) setEditCameraError('');
};

const handleEditFilterOptions = (options, params) => {
  const filter = createFilterOptions();
  const filtered = filter(options, params);
  
  const availableCameras = filtered.filter(camera => {
    if (editActiveCameras.includes(camera.deviceid)) return true;
    
    return !assignedCameraIds.includes(camera.deviceid) || 
           editingRow?.cameras?.some(c => (c.camera_id || c.CameraId) === camera.deviceid);
  });
  
  return [{ title: 'Select All', all: true }, ...availableCameras];
};


const handleCloseEditDialog = () => {
  setEditDialogOpen(false);
  setEditingRow(null);
  setEditType('');
  setEditPricing('');
  setEditNoOfCameras('');
  setEditNoOfViews('');
  setEditViewsConsideredForBilling('');
  setEditStoragePrice('');
  setEditActiveCameras([]);
  setEditSelectedCameras([]);
  setEditActiveGroups([]);
  setEditClientGroupList([]);
  setEditGroupInfo([]);
  setEditClientLocationOptions([]);
  setEditSelectedLocation(null);
  setEditTypeError('');
  setEditPricingError('');
  setEditCameraError('');
  setEditGroupError('');
  setEditLocationError('');
  setEditErrorMessage('');
};



  const handleClear = () => {
  setLiveCamerasList([]);
  setSelectedCameras([]);
  setSelectedGroup("");
  setCamerasByGroup([]);
  setSubmitted(false);
  setActiveCameras([]);
  setOpenAuto(false);
  setInputValue([]);
  setCheckValue(false);
  setGroupCheckValue(false);
  setActiveGroups([]);
  setClient('');
  setType('View');
  setPricing('');
  setNoOfCameras('');
  setNoOfViews('');
  setNoOfViewsForBilling('');
  setStoragePrice('');
  setTypeError('');
  setPricingError('');
  setLocationError('');
  setErrorMessage('');
  setErrorGroup(null);
  setSaveError(false);
  setClientLocationOptions([]);
  setSelectedClientLocations([]);
  if (!isClient) {
    setSelectedClient(null);
  }
  hasTriggeredSubmit.current = false;
};

  

			  const handleLiveCamera = (event, newValue = []) => {
	    if ((!newValue || newValue.length === 0) && liveCamerasList.length === 0) {
	      setLiveCamerasList([]);
	    }

	    if (newValue.length > 1 && newValue.every((entry, index, arr) => JSON.stringify(entry) === JSON.stringify(arr[0]))) {
	      newValue = [];
	    }

	    const cameraValues = getAvailableCameraOptions();
	    const availableCameraIds = cameraValues.map((camera) => camera.deviceid);
	    const containsAllProperty = newValue.some((obj) => obj?.all);

	    if (containsAllProperty) {
	      if (checkValue) {
	        setSelectedCameras([]);
	        setActiveCameras([]);
	        setInputValue([]);
	        setCheckValue(false);
	      } else {
	        setSelectedCameras(cameraValues);
	        setActiveCameras(availableCameraIds);
	        setInputValue(cameraValues);
	        setCheckValue(cameraValues.length > 0);
	      }

	      setErrorMessage('');
	      return;
	    }

	    const selectedCameraValues = newValue.filter((camera) => camera?.deviceid && !isCameraDisabled(camera));
	    const selectedCameraIds = selectedCameraValues.map((camera) => camera.deviceid);

	    setSelectedCameras(selectedCameraValues);
	    setActiveCameras(selectedCameraIds);
	    setInputValue(selectedCameraValues);
	    setCheckValue(
	      availableCameraIds.length > 0 &&
	      selectedCameraIds.length === availableCameraIds.length &&
	      availableCameraIds.every((cameraId) => selectedCameraIds.includes(cameraId))
	    );
	    setErrorMessage('');
	  };



 
  const handleFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);

    const selectedOptions = filtered.filter(option => activeCameras.includes(option.deviceid));
    const unselectedOptions = filtered.filter(option => !activeCameras.includes(option.deviceid));

    const sortedOptions = [...selectedOptions, ...unselectedOptions];
    return [{ title: 'Select All', all: true }, ...filtered];
  };

  const handleGroupFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    return [{ title: 'Select All', all: true }, ...filtered];
  };

    const handleTypeChange = (event) => {
        const selectedType = event.target.value;
        setType(selectedType);
        if (selectedType) {
            setTypeError('');
        }
    };

    const handleEditTypeChange = (event) =>{
      const selectedType = event.target.value;
        setEditType(selectedType);
    }

	  const handlePricingChange = (event) => {
	    const value = event.target.value;
	    // Allow currency values
	    if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
	        setPricing(value);
	        setPricingError('');
	    } else {
	        setPricingError('Please enter numbers only');
	    }
	    };

      const handleIntegerFieldChange = (setter) => (event) => {
        const value = event.target.value;
        if (value === '' || /^\d+$/.test(value)) {
          setter(value);
        }
      };

      const handleAmountFieldChange = (setter) => (event) => {
        const value = event.target.value;
        if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
          setter(value);
        }
      };

	    const getAvailableCameraOptions = () => {
	      let cameraValues = clientGroupList.length ? camerasByGroupId : camerawithoutGroups;

	      if (assignedCameraIds.length > 0) {
	        cameraValues = cameraValues.filter((val) =>
	          !assignedCameraIds.some((cameraId) => Number(cameraId) === Number(val.deviceid))
	        );
	      }
	
	      return cameraValues;
	    };

	     useEffect(() => {
        if (status && message) {
            const timer = setTimeout(() => {
            setMessage('');
            setStatusBase(false);
            }, 2000); // 2 seconds

            return () => clearTimeout(timer); 
        }
    }, [status, message]);

		    const isCameraDisabled = (camera) =>
		      assignedCameraIds.some((cameraId) => Number(cameraId) === Number(camera?.deviceid));

	      const isCameraSelectionDisabled = (camera) =>
	        isCameraDisabled(camera);
	      const hasClientSelection = isClient ? !!client : !!selectedClient;
	      const hasRequiredLocationSelection = clientLocationOptions.length === 0 || selectedClientLocations.length > 0;
	      const isCameraDropdownDisabled = !hasClientSelection || !hasRequiredLocationSelection;


  return (
    <Page title="Price">
      <Card variant="outlined" sx={{ p: 1 }}>
        <CardContent>  
          <Typography variant="h4" >Price</Typography>    
          <Grid container spacing={2} mt={1}>          
              {/* Removed Client Type dropdown completely */}
              
              {!isClient && (
              <Grid item xs={2}>
                  <FormControl fullWidth>
                  <Autocomplete
                      fullWidth
                      id="tags-outlined"
                      options={uniqueClientOptions.map((client, clientIndex) => ({
                      ...client,
                      customKey: `${client.ID || client.id}-${clientIndex}`,
                      }))}
                      isOptionEqualToValue={(option, value) =>
                      option.customKey === value.customKey
                      }
                      getOptionLabel={(option) =>
                      option
                        ? `${option.displayname || ''}`
                        : ''
                    }
                      onChange={(event, val) => {
                      setSelectedClient(val);
                      handleClient(event, val);
                      }}
                      value={selectedClient}
                      renderInput={(params) => (
                      <TextField
                          {...params}
                          label="Select Client"
                          placeholder="Enter Client Name"
                      />
                      )}
                      renderOption={(props, option) => (
                      <li {...props} key={option.ID}>
                        {option.displayname}
                      </li>
                    )}
                  />
                  {(saveError) && (
                      <Typography variant="body2" color="error">Please select a client.</Typography>
                  )}
                  </FormControl>
              </Grid>
              )}
              {selectedClient && clientLocationOptions.length > 0 && (
                <Grid item xs={2}>
                  <Autocomplete
                    id="tags-outlined-locations"
                    options={clientLocationOptions}
                    onChange={handleLocationChange}
                    value={
                      clientLocationOptions.find((location) =>
                        selectedClientLocations.includes(location.ID || location.id)
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) =>
                      Number(option?.ID ?? option?.id) === Number(value?.ID ?? value?.id)
                    }
                    getOptionLabel={(option) => `${option?.Location || ''}`}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Location"
                        placeholder="Search Location..."
                        error={!!locationError}
                        helperText={locationError}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.ID || option.id}>
                        {option.Location}
                      </li>
                    )}
                  />
                </Grid>
              )}
              {false && (clientGroupList.length > 0) && (
              <Grid item xs={2}>
                  <Autocomplete
                  multiple
                  id="tags-outlined-groups"
                  options={clientGroupList}
                  onChange={handleGroupChange}
                  value={[]}
                  disableCloseOnSelect
                  renderInput={(params) => (
                      <TextField
                      {...params}
                      label="Select Groups"
                      placeholder="Search Group Name..."
                      />
                  )}
                  filterOptions={handleGroupFilterOptions}
                  renderOption={(props, option, { selected }) => (
                      <li {...props}>
                      {option.all ? (
                          <>
                          <Checkbox
                              icon={groupicon}
                              checkedIcon={groupcheckedIcon}
                              style={{ marginRight: 8 }}
                              checked={groupCheckValue}
                          />
                          {option.title}
                          </>
                      ) : (
                          <>
                          <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={activeGroups.includes(option.GroupId)}
                              onChange={() => {
                              const isChecked = activeGroups.includes(option.GroupId);
                              const newActiveGroups = isChecked
                                  ? activeGroups.filter((groupId) => groupId !== option.GroupId)
                                  : [...activeGroups, option.GroupId];
                              setActiveGroups(newActiveGroups);
                              }}
                          />
                          {`${option.GroupName}`}
                          </>
                      )}
                      </li>
                  )}
                  isOptionEqualToValue={(option, value) => option.GroupId === value.GroupId}
                  />
                  {errorGroup && (
                  <Typography color="error" variant="body2" align="center">{errorGroup.message}</Typography>
                  )}
              </Grid>
              )}
                  {false && (
			              <Grid item xs={3}>
				              <Autocomplete
				                  multiple
				                  id="tags-outlined-cameras"
	                  open={openAuto}
	                  onClose={() => setOpenAuto(false)}
	                    disabled={isCameraDropdownDisabled}
		                  options={clientGroupList.length > 0 ? camerasByGroupId :  camerawithoutGroups}
		                  onOpen={() => {
		                    setOpenAuto(true);
		                  }}
	                  getOptionLabel={(option) => {
	                  if (!option || typeof option !== 'object') return "";
	                  if (option.all) return option.title || "Select All";
	                  return option.devicename || "";
	                  }}
			                  getOptionDisabled={(option) => {
			                    if (option.all) {
			                      return getAvailableCameraOptions().length === 0;
			                    }
			                    return isCameraSelectionDisabled(option);
	                  }}
                  onChange={handleLiveCamera}
                  disableCloseOnSelect
                  filterOptions={handleFilterOptions}
                  onInputChange={(event, newInputValue) => {
                  if (!newInputValue) setLiveCamerasList([]);
                  }}
                  value={
                  checkValue
                      ? [{ title: 'Select All', all: true }]
                      : inputValue.filter((camera) =>
                          clientGroupList.length
                          ? activeCameras.includes(camera.deviceid)
                          : activeCameras.includes(camera.deviceid)
                      )
                  }
                  renderTags={() => null}
                  clearOnBlur={true}
                  sx={{
                  '& .MuiOutlinedInput-root': {
                    
                      color: '#e0e0e0',
                  },
                  '& .MuiInputLabel-root': {
                      color: '#b0bec5',
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#616161',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#9e9e9e',
                  },
                  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#90caf9',
                  },
                  }}
                  renderInput={(params) => (
			                  <TextField
			                      {...params}
			                      label="Select Camera View"
			                      placeholder="Search by Camera Name..."
			                      InputLabelProps={{ style: { color: '#b0bec5' } }}
			                  />
		                  )}
	                  renderOption={(props, option, { selected }) => {
	                    const optionDisabled = !option.all && isCameraSelectionDisabled(option);

	                    return (
	                  <li
	                    {...props}
	                    style={{
	                      backgroundColor: '#303030',
	                      color: '#e0e0e0',
	                      opacity: optionDisabled ? 0.5 : 1,
	                      pointerEvents: optionDisabled ? 'none' : 'auto'
	                    }}
	                  >
		                      {option.all ? (
	                          <>
	                              <Checkbox
	                                  icon={icon}
	                                  checkedIcon={checkedIcon}
	                                  style={{ marginRight: 8, color: '#90caf9' }}
		                                  checked={checkValue}
	                                    disabled={getAvailableCameraOptions().length === 0}
		                                  onChange={() => setCheckValue(!checkValue)}
	                              />
	                              {option.title}
	                          </>
	                      ) : (
                          <>
	                              <Checkbox
	                                  icon={icon}
	                                  checkedIcon={checkedIcon}
	                                  style={{ marginRight: 8, color: '#90caf9' }}
	                                  checked={activeCameras.includes(option.deviceid)}
                                    disabled={isCameraSelectionDisabled(option)}
	                                  onChange={() => {
	                                      const isChecked = activeCameras.includes(option.deviceid);
	                                      const newActiveCameras = isChecked
	                                          ? activeCameras.filter((id) => id !== option.deviceid)
                                          : [...activeCameras, option.deviceid];
                                      setActiveCameras(newActiveCameras);
                                  }}
                              />
                              {option.devicename}
                          </>
		                      )}
	                  </li>
	                    );
	                  }}
	              />
              {errorMessage && (
                  <Typography color="error" variant="body2" align="center">
                  {errorMessage}
                  </Typography>
              )}
	              </Grid>
                  )}

              <Grid item xs={1}>
                  <TextField
                      fullWidth
	                      label="No of Cameras"
                      value={noOfCameras}
                      onChange={handleIntegerFieldChange(setNoOfCameras)}
                      inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      }}
                  />
              </Grid>

              <Grid item xs={1}>
                  <TextField
                      fullWidth
	                      label="No of Views"
                      value={noOfViews}
                      onChange={handleIntegerFieldChange(setNoOfViews)}
                      inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      }}
                  />
              </Grid>

              <Grid item xs={2}>
                  <TextField
                      fullWidth
	                      label="No of Views for Billing"
                      value={noOfViewsForBilling}
                      onChange={handleIntegerFieldChange(setNoOfViewsForBilling)}
                      inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      }}
                  />
              </Grid>

              {false && (
              <Grid item xs={1}>
                  <FormControl fullWidth error={!!typeError}>
                      <InputLabel id="type-select-label">Type</InputLabel>
                      <Select
                      labelId="type-select-label"
                      id="type-select"
                      value={type}
                      label="Type"
                      onChange={handleTypeChange}
                      >
                      <MenuItem value="View">View</MenuItem>
                      {/* <MenuItem value="Group">Group</MenuItem> */}
                      </Select>
                      {typeError && (
                      <Typography variant="caption" color="error">
                          {typeError}
                      </Typography>
                      )}
                  </FormControl>
              </Grid>
              )}

              <Grid item xs={1}>
	                  <TextField
	                      fullWidth
	                      label="Total Price"
	                      value={pricing}
	                      onChange={handlePricingChange}
                      error={!!pricingError}
                      helperText={pricingError}
                      InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      }}
	                      inputProps={{
                      inputMode: 'decimal',
	                      }}
	                  />
	              </Grid>

              <Grid item xs={1}>
                  <TextField
                      fullWidth
                      label="Storage Price"
                      value={storagePrice}
                      onChange={handleAmountFieldChange(setStoragePrice)}
                      InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                      }}
                      inputProps={{
                      inputMode: 'decimal',
                      }}
                  />
              </Grid>

              <Grid item xs={2} sx={{marginTop:'10px'}}>
              <Stack direction="row" spacing={1} alignItems="center">
                  <LoadingButton variant="contained" onClick={handleSubmit}>
                  Submit
                  </LoadingButton>
                  {/* <LoadingButton
                  variant="contained"
                  color="error"
                  onClick={handleClear}
                  >
                  Cancel
                  </LoadingButton> */}
              </Stack>
              </Grid>          
          </Grid>  

            {errorMessage && (
                <Stack direction="row" sx={{ paddingTop: 2 }}>
                    <Alert severity="error" sx={{ width: '30%' }}>
                    {errorMessage}
                    </Alert>
                </Stack>
            )}

            {(status && message) && (
                <Stack direction="row" sx={{ paddingTop: 2 }}>
                    <Alert 
                    severity={alertType}
                    sx={{
                        width: '30%',
                        opacity: 0,
                        animation: 'fadeInOut 2.5s ease-in-out',
                        '@keyframes fadeInOut': {
                        '0%': { opacity: 0 },
                        '20%': { opacity: 1 },
                        '80%': { opacity: 1 },
                        '100%': { opacity: 0 },
                        }
                    }}
                    >
                    {message}
                    </Alert>
                </Stack>
          ) }

          <Grid container spacing={3} alignItems="center" sx={{ marginTop: "40px", width:'100%', marginLeft:'0px' }}>
            <Scrollbar>
              <TableContainer>
                <Table stickyHeader>
	                  <TableHead sx={{ background: "#f3f3f3" }}>
	                    <TableRow sx={{ background: '#f3f3f3' }}>
	                      <TableCell>S.No</TableCell>
	                      <TableCell>Client Name</TableCell>
                        <TableCell>Location</TableCell>
	                      <TableCell>No Of Cameras</TableCell>
	                      <TableCell>No Of Views</TableCell>
		                      <TableCell>Views Considered For Billing</TableCell>
		                      <TableCell>Total Price</TableCell>
		                      <TableCell>Storage Price</TableCell>
		                      <TableCell>Action</TableCell>
	                    </TableRow>
	                  </TableHead>
	                  <TableBody>
	                    {pricingData.map((row, index) => (
	                      <TableRow key={row.id || index}>
	                        <TableCell>{index + 1}</TableCell>
	                        <TableCell>{row.ClientName}</TableCell>
	                        <TableCell>{row.Location}</TableCell>
	                        <TableCell>{row.NoOfCameras}</TableCell>
	                        <TableCell>{row.NoOfViews}</TableCell>
		                        <TableCell>{row.ViewsConsideredForBilling}</TableCell>
		                        <TableCell>{row.TotalPrice}</TableCell>
		                        <TableCell>{row.StoragePrice}</TableCell>
		                        <TableCell>
		                          <Button
		                            style={{ color: "#fff" }}
		                            variant="contained"
		                            onClick={() => handleEdit(row)}
		                          >
		                            Edit
		                          </Button>
		                        </TableCell>
		                      </TableRow>
	                    ))}
	                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Grid>
          
        </CardContent>

      <Dialog 
  open={editDialogOpen} 
  onClose={handleCloseEditDialog}
  maxWidth="md"
  fullWidth>
	  <DialogTitle>
	    Edit Billing Pricing
	  </DialogTitle>
	  <DialogContent dividers>
	    <Grid container spacing={2} mt={1}>
	      <Grid item xs={12} md={4}>
	        <TextField
	          fullWidth
	          label="Client"
	          // value={editingRow?.ClientId ?? ''}
            value={getClientNameById(editingRow?.ClientId)}
	          disabled
	        />
	      </Grid>

	      <Grid item xs={12} md={4}>
	        <TextField
	          fullWidth
	          label="No of Cameras"
	          value={editNoOfCameras}
	          onChange={handleIntegerFieldChange(setEditNoOfCameras)}
	          inputProps={{
	            inputMode: 'numeric',
	            pattern: '[0-9]*',
	          }}
	        />
	      </Grid>

	      <Grid item xs={12} md={4}>
	        <TextField
	          fullWidth
	          label="No of Views"
	          value={editNoOfViews}
	          onChange={handleIntegerFieldChange(setEditNoOfViews)}
	          inputProps={{
	            inputMode: 'numeric',
	            pattern: '[0-9]*',
	          }}
	        />
	      </Grid>

	      <Grid item xs={12} md={4}>
	        <TextField
	          fullWidth
	          label="Views Considered For Billing"
	          value={editViewsConsideredForBilling}
	          onChange={handleIntegerFieldChange(setEditViewsConsideredForBilling)}
	          inputProps={{
	            inputMode: 'numeric',
	            pattern: '[0-9]*',
	          }}
	        />
	      </Grid>

	      <Grid item xs={12} md={4}>
	        <TextField
	          fullWidth
	          label="Total Price"
	          value={editPricing}
	          onChange={(e) => {
	            const value = e.target.value;
	            if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
	              setEditPricing(value);
	              setEditPricingError('');
	            } else {
	              setEditPricingError('Please enter numbers only');
	            }
	          }}
	          error={!!editPricingError}
	          helperText={editPricingError}
	          InputProps={{
	            startAdornment: <InputAdornment position="start">$</InputAdornment>,
	          }}
	          inputProps={{
	            inputMode: 'decimal',
	          }}
	        />
	      </Grid>

	      <Grid item xs={12} md={4}>
	        <TextField
	          fullWidth
	          label="Storage Price"
	          value={editStoragePrice}
	          onChange={handleAmountFieldChange(setEditStoragePrice)}
	          InputProps={{
	            startAdornment: <InputAdornment position="start">$</InputAdornment>,
	          }}
	          inputProps={{
	            inputMode: 'decimal',
	          }}
	        />
	      </Grid>
      
      {editErrorMessage && (
        <Grid item xs={12}>
          <Alert severity="error" sx={{ mt: 1 }}>
            {editErrorMessage}
          </Alert>
        </Grid>
      )}
    </Grid>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseEditDialog}>Cancel</Button>
    <Button variant="contained" onClick={handleSaveEdit}>
      Save Changes
    </Button>
  </DialogActions>
</Dialog>
      </Card>
    </Page>
  );
}
